import { createFileRoute } from '@tanstack/react-router';
import { NewsletterOverviewRouteView } from '@/pages/workspaces/broadcasts/newsletter/overview/routing';

function NewsletterOverviewRoute() {
  const { newsletterId } = Route.useParams();
  return <NewsletterOverviewRouteView newsletterId={newsletterId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview',
)({
  component: NewsletterOverviewRoute,
});
